import {
  Badge,
  Card,
  Col,
  Empty,
  Row,
  Space,
  Statistic,
  Typography,
} from "antd";
import { BillingPreview } from "@/models/billing-preview";
import { renderDate } from "@/utils";
import { InternalInvoiceItemsTable } from "./internal-invoice-items-table";
import "./billing-preview-cards.less";

const { Text, Title } = Typography;

export function BillingPreviewCards(props: { preview: BillingPreview | null }) {
  const { preview } = props;

  if (!preview) {
    return (
      <Card className="billing-preview-section">
        <Empty description="Preview not available yet" />
      </Card>
    );
  }

  const currency = preview.amount?.currency;

  return (
    <div className="billing-preview-section">
      <div className="billing-preview-header">
        <Space align="center">
          <Title level={4} style={{ margin: 0 }}>
            Cost preview — {preview.monthLabel}
          </Title>
          <Badge count="Preview" style={{ backgroundColor: "#1677ff" }} />
        </Space>
        <Text type="secondary">Updated: {renderDate(preview.date)}</Text>
      </div>

      <Row gutter={[16, 16]} className="billing-preview-stats">
        <Col xs={24} sm={8}>
          <Card>
            <Statistic
              title="Recovered Amount"
              value={preview.recoveredAmount?.value}
              precision={2}
              prefix={currency?.symbol}
            />
          </Card>
        </Col>
        <Col xs={24} sm={8}>
          <Card>
            <Statistic
              title="Amount"
              value={preview.amount?.value}
              precision={2}
              prefix={currency?.symbol}
            />
          </Card>
        </Col>
        <Col xs={24} sm={8}>
          <Card>
            <Statistic title="Invoice numbers" value={preview.items.length} />
          </Card>
        </Col>
      </Row>

      {preview.items.length > 0 && (
        <Card className="billing-preview-detail">
          <InternalInvoiceItemsTable
            items={preview.items}
            title="Details"
            exportFilename={`billing-preview-${preview.year}-${String(preview.month).padStart(2, "0")}-details.csv`}
            exportButtonSize="middle"
          />
        </Card>
      )}
    </div>
  );
}
